import { createContext } from "react";

/**
 * The owning route's in-content back action for `MorphemeFlashcardPanel`. `MorphemeFlashcardPanelsLayout`
 * provides it from the `(panels)` layout, where the route's navigator is in scope — the panel
 * screen below renders inside that layout's Slot, so its own `useNavigation` sees a different
 * navigator.
 */
export const MorphemeFlashcardPanelBackContext = createContext<(() => void) | undefined>(undefined);
